import * as St from './Colors.styles';

import PageTitle from '~atoms/PageTitle';

type ColorsProps = React.PropsWithChildren<{
  subtitleSlot?: JSX.Element;
  filtersSlot: JSX.Element;
}>;

const Colors = ({ subtitleSlot, filtersSlot, children }: ColorsProps) => (
  <St.Container>
    <PageTitle>Color</PageTitle>
    {subtitleSlot}
    <St.ContentContainer>
      <St.FilterContainer>{filtersSlot}</St.FilterContainer>
      <St.ChildrenContainer>{children}</St.ChildrenContainer>
    </St.ContentContainer>
  </St.Container>
);

export default Colors;
